export default "__VITE_ASSET__b149dfa4__"